import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      // Wait a tick for the next route to render before scrolling.
      window.requestAnimationFrame(() => {
        const targetId = decodeURIComponent(hash.replace('#', ''))
        const el = document.getElementById(targetId)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
          return
        }
        // Fallback if the element isn't found.
        window.scrollTo(0, 0)
      })
      return
    }

    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}

export default ScrollToTop

